import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import apiTracking from '../../utils/tracking/apiTracking';

const eventMappings = {};
eventMappings[actions.ELECTION_REMINDER_COMPLETED] = [trackCompleteAction];
eventMappings[actions.ELECTION_REMINDER_CANCELED] = [trackCancelAction];

export default function trackElectionReminder(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackCompleteAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCompleteTime: state.electionReminder.actionCompletionTime
    });
}

function trackCancelAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_CANCELED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCancelTime: state.electionReminder.actionCancelTime
    });

    apiTracking.trackCancelAction(state, state.electionReminder.actionCancelledTime);
}
